import { validerCheminFavori } from '@gestion/shared/favoris'
import type { EtatFavoris, Favori } from './favoris.js'

/**
 * « AJOUTER AUX FAVORIS » DANS LES MENUS CLIC DROIT — la décision, en calcul
 * pur (lot 6, 24/10/2026 ; tests/menu-favori.test.ts). `menu-favori.tsx` n'y
 * ajoute que les icônes et le geste.
 *
 * Seuls imports : le validateur partagé avec le serveur, et des types.
 *
 *   · aucun   : pas de session, ou une adresse que le validateur refuse (une
 *               ancre, un chemin hors de Gestion, une page de connexion) ;
 *   · retirer : l'adresse est déjà épinglée, au caractère près — paramètres
 *               compris, comme l'étoile ;
 *   · ajouter : grisé tant que la liste n'est pas lue, quand sa lecture a
 *               échoué, ou quand les 30 favoris sont pris.
 */

export type PlanFavori =
  | { sorte: 'aucun' }
  | { sorte: 'retirer'; favori: Favori }
  | { sorte: 'ajouter'; chemin: string; indisponible: string | null }

export const FAVORIS_PAS_LUS = 'Favoris pas encore lus : rouvrez le menu'
export const FAVORIS_ILLISIBLES = 'Favoris indisponibles pour l’instant'
export const favorisPleins = (max: number): string => `${max} favoris au plus : retirez-en un`

export function planFavori(e: Pick<EtatFavoris, 'userId' | 'statut' | 'liste' | 'max'>, href: string): PlanFavori {
  if (!e.userId || e.statut === 'vide') return { sorte: 'aucun' }
  const verdict = validerCheminFavori(href)
  if (!verdict.ok) return { sorte: 'aucun' }
  const chemin = verdict.chemin
  const deja = e.liste.find((f) => f.path === chemin)
  if (deja) return { sorte: 'retirer', favori: deja }
  const indisponible = e.statut === 'chargement' ? FAVORIS_PAS_LUS
    : e.statut !== 'pret' ? FAVORIS_ILLISIBLES
      : e.liste.length >= e.max ? favorisPleins(e.max)
        : null
  return { sorte: 'ajouter', chemin, indisponible }
}
